// extracted by mini-css-extract-plugin
export var addToCartButton = "_oo-b";
export var arrowButtonContainer = "_oo-9";
export var arrowButtonIcon = "_oo-a";
export var carouselArrowButton = "_oo-6";
export var carouselElementContainer = "_oo-1";
export var left = "_oo-7";
export var productDisplayCarouselContainer = "_oo-0";
export var productTileContainer = "_oo-2";
export var productTileImage = "_oo-4";
export var productTileImageContainer = "_oo-3";
export var productTileTitle = "_oo-5";
export var right = "_oo-8";
export var sliderOverflow = "_oo-c";